import { render, staticRenderFns } from "./ARecaptchaOptions.vue?vue&type=template&id=48cb604e&"
import script from "./ARecaptchaOptions.vue?vue&type=script&lang=js&"
export * from "./ARecaptchaOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports